import CreateEditEntityTemplateModal from '@/ui/components/createEditEntityTemplateModal/CreateEditEntityTemplateModal';
import { BLANK_ENTITY_TEMPLATES } from '@/ui/components/createEditEntityTemplateModal/blankEntityTemplates';
import { Button } from '@payaca/ambrosia';
import { PublicEntityTemplate } from '@payaca/types/entity-templates';
import UntitledIcon from '@payaca/untitled-icons';
import { FC, useState, type JSX } from 'react';
import EntityTemplateCard from '../entityTemplateCard/EntityTemplateCard';
import './ScheduledEventLinkedTaskTemplatesPanel.sass';

type Props = {
  taskTemplates: Omit<PublicEntityTemplate<'task'>, 'publicId'>[];
  onChange: (
    taskTemplates: Omit<PublicEntityTemplate<'task'>, 'publicId'>[]
  ) => Promise<void>;
};
const ScheduledEventLinkedTaskTemplatesPanel: FC<Props> = ({
  taskTemplates,
  onChange,
}: Props): JSX.Element | null => {
  const [showCreateTaskTemplateModal, setShowCreateTaskTemplateModal] =
    useState(false);

  return (
    <div className={'scheduled-event-linked-task-templates-panel'}>
      <Button
        aria-label="Add task template"
        className="self-end"
        variant="secondary"
        size="xs"
        onClick={() => setShowCreateTaskTemplateModal(true)}
      >
        <UntitledIcon name="plus.3" className="h-3.5 w-3.5" />
      </Button>
      {taskTemplates.map((t, i) => {
        return (
          <EntityTemplateCard
            editInModal={false}
            showEntityTypeIcon={true}
            key={i}
            template={t}
            isChildOfScheduledEvent
            allowedQuickActions={['delete']}
            onChange={(updatedTaskTemplate) =>
              new Promise<void>((resolve, reject) => {
                const updatedTaskTemplates = [...taskTemplates];
                updatedTaskTemplates[i] = updatedTaskTemplate as Omit<
                  PublicEntityTemplate<'task'>,
                  'publicId'
                >;
                onChange(updatedTaskTemplates).then(resolve).catch(reject);
              })
            }
            onRemove={() =>
              new Promise<void>((resolve, reject) => {
                onChange(taskTemplates.filter((_, j) => j !== i))
                  .then(resolve)
                  .catch(reject);
              })
            }
            onClick={(showEditTemplateModal) => showEditTemplateModal()}
          />
        );
      })}
      <CreateEditEntityTemplateModal
        isOpen={showCreateTaskTemplateModal}
        onClose={() => setShowCreateTaskTemplateModal(false)}
        action="Create"
        isChildOfScheduledEvent
        template={BLANK_ENTITY_TEMPLATES.task}
        onRequestSave={(newEntityTemplate) => {
          void onChange([
            ...taskTemplates,
            newEntityTemplate as Omit<PublicEntityTemplate<'task'>, 'publicId'>,
          ])
            .then(() => setShowCreateTaskTemplateModal(false))
            // Keep the modal open so the unsaved Task is not lost. The failure
            // is already reported by the caller.
            .catch(() => undefined);
        }}
      />
    </div>
  );
};
export default ScheduledEventLinkedTaskTemplatesPanel;
